import CheckCircle from '../icons/CheckCircle';
import { MaterialIcon } from '../MaterialIcon';
import { RichText } from '../RichText';

export type RenderListProps = {
  items: Array<string>;
  type: 'pros' | 'cons' | 'usp_labels';
  className?: string;
};

export const renderListProsCons = ({
  items,
  type,
  className = '',
}: RenderListProps) => {
  if (!items.length) return null;

  const getIcon = () => {
    switch (type) {
      case 'pros':
        return (
          <CheckCircle className="absolute -left-8 top-0 text-highlights/green-dark" />
        );
      case 'cons':
        return (
          <MaterialIcon
            icon="cancel"
            className="absolute -left-8 top-0 text-highlights/red-dark"
          />
        );
      case 'usp_labels':
        return (
          <div className="absolute -left-6 top-1.5 size-2 rounded-full bg-current text-text/secondary-lighter" />
        );
      default:
        return null;
    }
  };

  const Icon = getIcon;

  return (
    <ul
      className={`ml-2 flex flex-col gap-spacing/gap/soft-6px px-padding/x text-text/primary alpha-bullet-2 ${className}`}
    >
      {items.map((item) => (
        <li key={item} className="relative">
          <Icon />
          <RichText component="span">{item}</RichText>
        </li>
      ))}
    </ul>
  );
};
